<template>
  <span class="txt-analysis-info">
    <font-awesome-icon icon="calendar-minus" /> {{ value.substring(0, 16) }}
  </span>
</template>

<script type="text/javascript">
export default {
  name: 'ClassTime',

  components: {},

  props: {
    // eslint-disable-next-line
    value: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
};
</script>
